import { ProjectReportField } from "./projectReportField";

type ProjectReport = {
  name: string;
  author: string;
  submissionDate: string;
  fields: (ProjectReportField & { value: string })[];
  attributes?: { [key: string]: string };
  templateId?: string;
};

const projectReport: ProjectReport = {
  author: "",
  name: "",
  submissionDate: "",
  fields: [],
};

export type { ProjectReport };

export { projectReport };
